<template>
	<span v-if="appLoaded">
		<v-app v-if="loggedIn">
			<v-app-bar app class="main-nav" v-if="role ===  'Admin'">
				<router-link :to="{name: 'transactions'}">
					<v-toolbar-title>Invoise Cloud Admin</v-toolbar-title>
				</router-link>
				<v-btn icon>
					<v-btn icon :to="{name: 'system'}" exact><v-icon :color="statusColor">far fa-power-off</v-icon></v-btn>
				</v-btn>
				<v-spacer></v-spacer>

				<v-toolbar-items>
					<!--<v-switch class="pr-5" style="padding-top:20px;" v-model="env"-->
					<!--true-value="Live" false-value="Dev" :label="env ? 'Live Db' : 'Dev Db'" color="warning" prepend-icon="far fa-database"></v-switch>-->
					<v-btn text :to="{name: 'partners'}" exact>Partners</v-btn>
					<v-btn text :to="{name: 'transactions'}" exact>Transactions</v-btn>
					<v-btn text :to="{name: 'queue'}">Queue</v-btn>
					<v-btn text :to="{name: 'test'}">Test</v-btn>
					<v-btn text :to="{name: 'systemstatus'}">Status</v-btn>
					<v-btn text :to="{name: 'reports'}">Reports</v-btn>
					<v-btn text :to="{name: 'workers'}">Workers</v-btn>
					<v-btn text @click="logout">{{username}} <v-icon style="margin-left:10px;">fal fa-sign-out-alt</v-icon></v-btn>
					<!--<v-btn text :to="{name: 'testfiles'}">Test Files</v-btn>-->
					<!--<v-btn text :to="{name: 'settings'}" :class="{badge: syncError}">-->
					<!--<v-badge color="warning">-->
					<!--<template v-slot:badge v-if="syncError"><span>!</span></template>-->
					<!--Settings-->
					<!--</v-badge>-->
					<!--</v-btn>-->
				</v-toolbar-items>
			</v-app-bar>
			<v-app-bar app class="main-nav" v-else>
				<router-link :to="{name: 'applications'}">
					<v-toolbar-title :to="{name: 'applications'}">Invoise Cloud Admin</v-toolbar-title>
				</router-link>
				<v-spacer></v-spacer>

				<v-btn text :to="{name: 'applications'}" exact>Applications</v-btn>
				<v-btn text @click="logout">{{username}} <v-icon style="margin-left:10px;">fal fa-sign-out-alt</v-icon></v-btn>
			</v-app-bar>
			<v-content>
				<v-alert
					:value="errorVisible"
					type="error"
					:dismissible="true"
					@input="errorClosed"
				>
					{{appError}}
				</v-alert>

				<v-snackbar
					v-model="toastVisible"
					:timeout="3000"
					:top="true"
					:color="toast.color"
				>
					{{toast.message}}
				</v-snackbar>

				<v-container>
					<v-row>
						<v-col class="mb-5" >
							<router-view :key="$route.fullPath"></router-view>
						</v-col>
					</v-row>
				</v-container>
			</v-content>
		</v-app>
		<v-app v-if="!loggedIn">
			<router-view :key="$route.fullPath"></router-view>
		</v-app>
	</span>
</template>

<script>
import api from "./api";
import "./style/app.less";
import { actionTypes, commitTypes } from "./store-types";

// TODO status icon refreshing

export default {
	components: {},
	data() {
		return {
			appLoaded: false,
			toastVisible: false,
			errorVisible: false,
			statusColor: "green",
			statusTimer: null,
		};
	},
	computed: {
		appError() {
			return this.$store.state.appError;
		},
		username() {
			return this.$store.state.username;
		},
		configLoaded() {
			return this.$store.state.configLoaded;
		},
		loggedIn() {
			return this.$store.state.loggedIn;
		},
		role() {
			return this.$store.state.role;
		},
		toast() {
			return this.$store.state.toast;
		},
	},
	created() {
		this.appLoaded = true;
		this.$store.commit(commitTypes.APP_STATE, true);
		this.refreshStatus();
	},
	mounted() {
		this.statusTimer = setInterval(this.refreshStatus, 30000);
	},
	watch: {
		appError(newVal) {
			if (!newVal) {
				this.errorVisible = false;
				return;
			}

			this.errorVisible = true;
		},
		toast(newVal) {
			if (!newVal.message) {
				this.toastVisible = false;
				return;
			}
			this.toastVisible = true;
		},
	},
	methods: {
		logout() {
			this.$store.dispatch(actionTypes.CLEAR_LOGIN);
		},
		errorClosed() {
			this.$store.commit(commitTypes.SET_ERROR, null);
		},
		refreshStatus() {
			api.system()
				.then((r) => {
					const status = r.data.status;

					if (status === "Online") {
						this.statusColor = "green";
					}
					if (status === "ShuttingDown") {
						this.statusColor = "amber";
					}
					if (status === "Offline") {
						this.statusColor = "red";
					}
				});
		},
	},
	beforeDestroy() {
		clearInterval(this.statusTimer);
	},
};
</script>
